import React, { useEffect } from "react";
import InSetBoxShadow from "../../../../Common/InSetBoxShadow";
import { borderBottomTitle } from "../../../../../Utils/styles";
import Loading from "../../../../Common/Loading";
import { useFilter } from "../../Hooks";
import { useSelector } from "react-redux";
import { GenderRender } from "../../../../Common/Function";
import { AiOutlineClose } from "react-icons/ai";
function Index({ handleFilter, getValue, clearFilters, search, filterDelete }) {
  const { loading, getTags, data } = useFilter();
  useEffect(() => {
    // if (!tags) {
    //   getTags();
    // }
  }, []);
  const { tags, categories, cities, sort } = useSelector(state => state);
  const arr = [
    {
      key: "name",
      type: "default",
    },
    {
      key: "item_gender",
      type: "gender",
    },
    {
      key: "city_id",
      type: "city",
    },
    {
      key: "sort",
      type: "sort",
    },
    {
      key: "tag",
      type: "tag",
    },
    {
      key: "category_id",
      type: "category_id",
    },
  ];
  const getLabel = ele => {
    switch (ele.type) {
      case "default":
        return getValue(ele.key);
      case "gender":
        return GenderRender(getValue(ele.key));
        break;
      case "city":
        return getValueFromArr(cities, ele.key);
      case "sort":
        return getValueFromArr(sort, ele.key);
        break;
      case "tag":
        let res = "";
        tags.map(tag => {
          if (tag.tags.id == getValue(ele.key)) {
            res = tag.tags.name;
          }
        });
        return res;
      case "category_id":
        return getValueFromArr(categories, ele.key);
      default:
        return "sal";
    }
  };
  const getValueFromArr = (arr = [], key) => {
    let res = "";
    arr.map(ele => {
      if (ele.id == getValue(key)) {
        res = ele.name;
      }
    });
    return res;
  };
  // if (!tags) {
  //   return <Loading count={1} height={"400"} />;
  // }
  return (
    <>
      <InSetBoxShadow
        style={{
          padding: "5px 15px",
        }}
      >
        <div
          style={{
            ...borderBottomTitle,
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex" style={{ fontWeight: "500" }}>
              <img
                src={window.origin + "/WebSide/assets/images/filter.png"}
                alt="فیلتر ها"
                style={{ width: "20px", height: "20px", marginLeft: "5px" }}
              />
              فیلترها
            </div>
            <button className="btn" onClick={clearFilters}>
              حذف فیلترها
            </button>
          </div>
          {/* <div className="d-flex flex-wrap my-2 mb-3">
            {arr.map((ele, key) => {
              if (getValue(ele.key) && ele.key !== "name") {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: "1px solid #eee",
                      borderRadius: "5px",
                      marginLeft: "5px",
                      fontSize: "11px",
                    }}
                    key={key}
                    className="mb-1 p-1"
                  >
                    <span>{getLabel(ele)}</span>
                    <button
                      className="btn p-0"
                      onClick={() => {
                        filterDelete(ele.key);
                      }}
                    >
                      <AiOutlineClose
                        size={12}
                        style={{ marginRight: "5px" }}
                      />
                    </button>
                  </div>
                );
              }
            })}
          </div> */}
        </div>
        <div
          style={{
            marginTop: "10px",
          }}
        >
          <h6
            style={{
              fontWeight: "500",
            }}
          >
            بر اساس جنسیت
          </h6>
          <div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                id="flexRadioDefault1"
                style={{ display: "block" }}
                onChange={() => {
                  handleFilter("item_gender", "men");
                }}
                checked={getValue("item_gender") === "men"}
              />
              <label
                className="form-check-label"
                htmlFor="flexRadioDefault1"
                style={{ fontWeight: "400" }}
              >
                آقایان{" "}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                id="flexRadioDefault2"
                style={{ display: "block" }}
                checked={getValue("item_gender") === "women"}
                onChange={() => {
                  handleFilter("item_gender", "women");
                }}
              />
              <label
                className="form-check-label"
                htmlFor="flexRadioDefault2"
                style={{ fontWeight: "400" }}
              >
                بانوان{" "}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                id="flexRadioDefault3"
                style={{ display: "block" }}
                onChange={() => {
                  handleFilter("item_gender", "both");
                }}
                checked={getValue("item_gender") === "both"}
              />
              <label
                className="form-check-label"
                htmlFor="flexRadioDefault3"
                style={{ fontWeight: "400" }}
              >
                هردو
              </label>
            </div>
          </div>
        </div>
        {/* <div
          style={{
            marginTop: "10px",
          }}
        >
          <h6>برچسب ها</h6>
          <div>
            {tags &&
              tags.map(tag => {
                return (
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tags"
                      id="flexRadioDefault1"
                      style={{ display: "block" }}
                      onClick={() => {
                        handleFilter("tag", tag.tags.id);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      {tag.tags.name}
                    </label>
                  </div>
                );
              })}
          </div>
        </div> */}
      </InSetBoxShadow>
    </>
  );
}

export default Index;
